import React, { useState } from "react";
// eslint-disable-next-line
import GravityForm from "~/components/forms/gravity-forms";
import { useConfigContext } from "~/providers/ConfigContextProvider";
import ReactSelect from "react-select";
import styled from "styled-components";
import { LoadingIcon } from "../ui/LoadingIcon";
import { FormErrors } from "../forms/FormErrors";
import { FormFields } from "../forms/FormFields";
import SafeHtmlDiv from "../ui/SafeHtmlDiv";
import { ErrorLock } from "../app/ErrorLock";

const FormContainer = styled(FormFields)`
  min-height: 500px;
  position: relative;

  .form-fields {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .form-field {
    width: 100%;
  }

  .form-title,
  .form-description {
    margin: 0;
  }

  button {
    &[type="submit"] {
      padding: 0 1em;
      display: flex;
      align-items: center;

      &.loading {
        background-color: #555;
      }
    }
  }

  .gsection_title {
    display: flex;
    align-items: flex-end;
    margin: 0;
  }

  .text,
  .textarea,
  .phone,
  .email,
  .website,
  .date,
  .select,
  .number {
    width: 100%;
  }

  .name {
    width: 100%;

    .name-fields {
      display: flex;
      justify-content: space-between;
    }
  }

  .address {
    flex-shrink: 1;
    min-width: calc(50% - 40px);
    &:nth-child(1),
    &:nth-child(2) {
      width: 100%;
    }
  }

  .fileupload {
    width: 100%;
    position: relative;
    overflow: hidden;

    display: flex;
    flex-wrap: wrap;
    label {
      width: 100%;
    }

    button {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    div {
      width: 100%;
      border: 1px solid #000;
      background: #fff;
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: center;
    }

    span {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 50%;
    }

    div.fileUpload {
      position: static;
    }
  }

  .checkboxes,
  .radios {
    width: 100%;

    .radio:last-child,
    .checkbox:last-child {
      padding-bottom: 0px;
    }
  }

  .react-datepicker-popper {
    z-index: 2;
    padding: 5px 0;
  }

  .react-datepicker {
    width: 50vw;
    min-width: 300px;
    max-width: 400px;
    background-color: #fff;
    border: 1px solid #000;

    position: relative;
    padding: 10px;
    .react-datepicker__navigation--previous {
      position: absolute;
      left: 10px;
      top: 10px;

      width: 2em;
      height: 2em;
      line-height: 2em;
      text-indent: -300px;
      overflow: hidden;
      background-color: #fff;
      &::after {
        position: relative;
        top: 0;
        left: 0;
        transform: translateY(-100%);
        display: block;
        content: "←";
        font-weight: 400;
        width: 2em;
        height: 2em;
        margin-top: 0.2em;
        margin-left: -0.2em;
        font-size: 1.2em;
        line-height: 2em;
        text-indent: 0px;
      }

      @media (any-pointer: fine) {
        &:hover {
          color: #555 !important;
        }
      }
    }
    .react-datepicker__navigation--next {
      position: absolute;
      right: 10px;
      top: 10px;

      width: 2em;
      height: 2em;
      line-height: 2em;

      text-indent: -300px;
      overflow: hidden;
      background-color: #fff;
      &::after {
        position: relative;
        top: 0;
        left: 0;
        transform: translateY(-100%);
        display: block;
        content: "→";
        font-weight: 400;
        width: 2em;
        height: 2em;
        margin-top: 0.2em;
        margin-right: 0.2em;
        font-size: 1.2em;
        line-height: 2em;
        text-indent: 0px;
      }

      @media (any-pointer: fine) {
        &:hover {
          color: #555 !important;
        }
      }
    }

    .react-datepicker__header {
      text-align: center;

      .react-datepicker__current-month {
        margin-top: 0.4em;
      }
    }

    .react-datepicker__day-names {
      display: flex;
      margin-top: 0.4em;
      justify-content: space-between;
    }

    .react-datepicker__week {
      display: flex;
      margin-top: 0.4em;
      justify-content: space-between;
    }
    .react-datepicker__day-name {
      width: 2em;
      height: 2em;
      text-align: center;
      line-height: 2em;
      font-weight: 700;
    }

    .react-datepicker__day {
      width: 2em;
      height: 2em;
      text-align: center;
      overflow: hidden;
      line-height: 2.1em;
      border-radius: 40px;
      transition: color 0.3s, background-color 0.3s;
      cursor: pointer;
      &.react-datepicker__day--selected {
        background-color: var(--ikon-hl-color, #ff0);
      }

      &.react-datepicker__day--today {
        background-color: #ccc;
      }

      &:hover {
        background-color: #000;
        color: #fff;
      }
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
  }

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        .form-title {
          margin-top: ${props.theme.spaceFontTop(breakpoint, `h3Heading`)};
        }

        .form-error {
          ${props.theme.textStyle(breakpoint, `h4Heading`)};
          padding-top: ${props.theme.spacePx(breakpoint, 5)};
          margin-bottom: ${props.theme.spacePx(breakpoint, 6)};
        }
        .form-confirmation {
          ${props.theme.textStyle(breakpoint, `h3`)};
        }

        .footer {
          height: ${props.theme.spacePx(breakpoint, 6)};
          margin-top: ${props.theme.spacePx(breakpoint, 7)};
        }

        .gsection_title {
          height: ${props.theme.spacePx(breakpoint, 6)};
          ${props.theme.textStyle(breakpoint, `h3`)};
          letter-spacing: 0;
        }
        .form-field {
          column-gap: ${props.theme.spacePx(breakpoint, 7)}; 
        }

        .description {
          padding-top: ${props.theme.spacePx(breakpoint, 10)};
          ${props.theme.textStyle(breakpoint, `caption`)};
        }

        .html-content {
          padding-top: ${props.theme.spacePx(breakpoint, 10)};
          ${props.theme.textStyle(breakpoint, `caption`)};
        }
        
        ${
          ["base", "mobile"].includes(breakpoint)
            ? `
            .form-field.small {
              width: calc(50% - ${(
                2 +
                props.theme.space(breakpoint, 7) / 2
              ).toFixed(2)}px) ;
            }
          `
            : `
            .form-field.small,
            .form-field.medium {
              width: calc(50% - ${(
                2 +
                props.theme.space(breakpoint, 7) / 2
              ).toFixed(2)}px) ;
            }
          `
        }
        
        .name .name-fields .name-field {
          width: calc(50% - ${(
            2 +
            props.theme.space(breakpoint, 7) / 2
          ).toFixed(2)}px) ;
        }

        button {
          &[type="submit"] {
          
            ${props.theme.textStyle(breakpoint, `h3Heading`)};
            height: ${props.theme.spacePx(breakpoint, 6)};
            max-width: ${props.theme.spacePx(breakpoint, 2)};
          }
        }

        .address {
          width: calc(50% - ${(
            2 +
            props.theme.space(breakpoint, 7) / 2
          ).toFixed(2)}px) ;
          &:nth-child(1),
          &:nth-child(2) {
            width: 100%;
          }
        }

        .fileupload {
          div {
            height: ${props.theme.spacePx(breakpoint, 6)};
            padding: 0 ${props.theme.spacePx(breakpoint, 9)};
          }

          button {
            height: ${props.theme.spacePx(breakpoint, 7)};
            padding: 0 ${props.theme.spacePx(breakpoint, 9)};
            ${props.theme.textStyle(breakpoint, `h4Heading`)};
          }

          span {
            margin-left: ${props.theme.spacePx(breakpoint, 8)};
          }          
        }
      
       
        .react-datepicker button {
          ${props.theme.textStyle(breakpoint, `h4Heading`)};
        }

        .react-datepicker,
        .react-datepicker__navigation--previous,
        .react-datepicker__navigation--next {
          ${props.theme.textStyle(breakpoint, `body`)};
        }

        .react-datepicker__current-month {
          ${props.theme.textStyle(breakpoint, `h4Heading`)};
        }        
        `;
    })}
`;

const StyledSelect = styled(ReactSelect)`
  .tabbed &:focus-within {
    outline-width: 3px;
    outline-color: var(--ikon-focus-color, #00f);
    outline-offset: 3px;
    outline-style: solid;
  }
  .form__menu {
    margin: 4px 0;
    background-color: #fff;
    border: 1px solid #000;
    box-shadow: none;
    border-radius: 0;

    .form__menu-list {
      padding: 0;
    }

    .form__option--is-focused {
      background-color: var(--ikon-hl-color, #ff0);
      color: #000;
    }

    .form__option--is-selected {
      background-color: #000;
      color: #fff;
    }
  }
  .form__control {
    border: 1px solid #000;
    border-radius: 0;
    min-height: 0;

    input {
      height: 100;
      width: 100%;
      border: 0;
      &:focus {
        box-shadow: none;
      }
    }

    .form__indicator-separator {
      background-color: #000;
    }

    &.form__control--is-focused {
      box-shadow: 0 0 0 1px #000;
    }

    .form__dropdown-indicator {
      color: #000;
      padding: 0 8px;
    }

    .form__single-value,
    .form__input-container,
    .form__value-container,
    .form__placeholder {
      padding: 0;
      margin: 0;
      width: 100%;
    }

    .form__single-value {
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: nowrap;

      color: #000;
    }

    cursor: pointer;

    
    @media (any-pointer: fine) {
      &:hover {
        border-color: #000;
      }
    }
  }

  .form-field.error & .form__control {
    border-color: var(--ikon-error-color, #c00);
    box-shadow: 0 0 0 1px var(--ikon-error-color, #c00);
  }

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        .form__control {
          height: ${props.theme.spacePx(breakpoint, 6)};
          
          .form__single-value,
          .form__placeholder {
            display: flex;
            align-items: center;
            height: calc(100% - 2px);
              ${props.theme.textStyle(breakpoint, `h3`)};
                padding: calc(0px ${props.theme.spaceFontTop(
                  breakpoint,
                  `h3`
                )}) ${props.theme.spacePx(
        breakpoint,
        10
      )} 0 ${props.theme.spacePx(breakpoint, 10)};
            font-weight: 400;
          }

          .form__input-container {
            ${props.theme.textStyle(breakpoint, `h3`)};
            font-weight: 400;
          }
          input,
          .form__input-container::after  {
            ${props.theme.textStyle(breakpoint, `h3`)};
            padding: calc(0px ${props.theme.spaceFontTop(
              breakpoint,
              `h3`
            )}) ${props.theme.spacePx(breakpoint, 10)} 0 ${props.theme.spacePx(
        breakpoint,
        10
      )} !important;
            font-weight: 400;
            height: ${props.theme.spacePx(breakpoint, 6)};     
            
          }
        }
        `;
    })}
`;

const scrollToFirstError = () => {
  const field: HTMLDivElement | null = document.querySelector("[required]");

  if (field)
    field.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
};

const ReactSelectComponent = (props: any) => {
  return <StyledSelect {...props} classNamePrefix="form" />;
};

export const BlockForm = ({ data, index }: { data: any; index: number }) => {
  const [hasErrors, setHasErrors] = useState(false);
  const [successMessage, setSuccessMessage] = useState<any>(null);
  const [isInit, setIsInit] = useState(false);
  const config = useConfigContext();
  const id = `#form-${index}-${data.gfFormId}`;

  return (
    <FormContainer id={id}>
      {successMessage && <div>{successMessage}</div>}
      <ErrorLock>
        <GravityForm
          backendUrl={`${config.apiUrl}/glamrock/v1/gf/forms`}
          formID={data.gfFormId}
          onChange={(values: any) => {
            if (isInit) {
              const invalid = Object.keys(values).filter(
                (key: any) => values[key].valid !== false
              );
              setHasErrors(invalid.length > 0);
            } else {
              if (values && Object.keys(values).length > 0) setIsInit(true);
            }
          }}
          onSubmitValidationError={(flag: boolean) => {
            setHasErrors(flag);
          }}
          // optional - calls after form has been submitted successfully
          // Attention onSubmitSuccess does overwrite full default behaviour.
          onSubmitSuccess={(response: any) => {
            if (typeof response === "object") {
              if (response?.is_valid) {
                const {
                  confirmation_redirect,
                  confirmation_type,
                  confirmation_message,
                } = response;
                if (confirmation_type === "redirect" && confirmation_redirect) {
                  window.location.replace(confirmation_redirect);
                  return false;
                }

                if (confirmation_type === "message" && confirmation_message) {
                  setSuccessMessage(
                    <SafeHtmlDiv html={confirmation_message} />
                  );
                }
              }
            }

            setHasErrors(false);
            return true; // returning false would stop the processing of react-gravity-forms onsubmit handler
          }}
          // optional - fires on GF error (gform_validation hook)
          styledComponents={{
            ReactSelect: ReactSelectComponent,
            Loading: LoadingIcon,
            FormConfirmation: FormErrors,
          }} // optional
          errorMessageServerProblem="Your submission could unfortunately not be fully processed on the server."
          errorMessageServerValidation="Your submission could not be processed on the server. Please check the form below for further information."
          // populatedFields={{parameterName: "Value"}}
          // jumpToConfirmation={false} // optional, default is equal to true
          // getParams={{}} // optional - pass an Object with your params to send the GF request with query string included
        />
      </ErrorLock>
      {hasErrors && (
        <FormErrors>
          Please complete the form to be able to submit it.{" "}
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              scrollToFirstError();
            }}
          >
            Scroll to first required field
          </a>
        </FormErrors>
      )}
    </FormContainer>
  );
};
export default BlockForm;
